import React from 'react'

export const VersionDisplay = () => {
  // Development ortamında veya undefined durumunda fallback
  const version = import.meta.env.VITE_APP_VERSION || '1.0.0'

  const handleReload = () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        for (const registration of registrations) {
          registration.unregister()
        }
      })
    }
    window.location.reload()
  }

  return (
    <button
      onClick={handleReload}
      className="text-[10px] font-mono text-gray-400 dark:text-gray-600 border border-gray-200 dark:border-zinc-800 rounded px-1.5 py-0.5 select-none opacity-60 hover:opacity-100 hover:bg-gray-100 dark:hover:bg-zinc-800 transition-all cursor-pointer flex items-center gap-1"
      title="Sürümü yenilemek için tıklayın"
    >
      v{version}
    </button>
  )
}
